module.exports = __webpack_public_path__ + "img/coupon-gift-top.255db03.png";